import crypto from 'crypto-js'

let key="8080808080808080";
function decrypt(encryptedData){
 return decryptaes(encryptedData,key);
};


 const decryptaes=(encryptedData, key)=> {
    var C = crypto;
    //encryptedData = C.enc.Base64.parse(encryptedData);                                // 3. Remove line
    var Key = C.enc.Utf8.parse("8080808080808080");
    var IV = C.enc.Utf8.parse("8080808080808080");
    //var decryptedText = C.AES.encrypt(encryptedData, Key, {
    var decryptedText = C.AES.decrypt(encryptedData, Key, {                             // 4. Use decrypt instead of encrypt
        iv: IV,
        mode: C.mode.CBC,
        padding: C.pad.Pkcs7
    });
    //return encryptedData.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedText.toString(crypto.enc.Utf8));                                   // 5. Use decryptedText instead of encryptedData
}

export default decrypt;